import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { V3_SCROLL_ROOT_ID } from "v3/constants";

/**
 * Resuelve el nodo cuyo scroll debe observarse para alinearlo con
 * `scrollableTarget={V3_SCROLL_ROOT_ID}` de `react-infinite-scroll-component`
 * cuando el dashboard UX / shell privado v3 está activo.
 *
 * @returns {Window|HTMLElement|null} `null` solo en entorno sin `window`.
 */
export function getPrivateShellScrollEventTarget() {
    if (typeof window === "undefined") {
        return null;
    }
    if (!isUxDashboardImprovementsEnabled()) {
        return window;
    }
    const el = document.getElementById(V3_SCROLL_ROOT_ID);
    return el || window;
}

/**
 * @returns {number} Posición vertical de scroll coherente con {@link getPrivateShellScrollEventTarget}.
 */
export function readPrivateShellScrollTop() {
    const target = getPrivateShellScrollEventTarget();
    if (!target) {
        return 0;
    }
    if (target === window) {
        return window.scrollY || document.documentElement.scrollTop || 0;
    }
    return target.scrollTop || 0;
}

/**
 * Registra el listener sobre ventana o `#app` según corresponda.
 *
 * @param {EventListener} handler
 * @returns {function(): void} Limpieza (idempotente).
 */
export function addPrivateShellScrollListener(handler) {
    const target = getPrivateShellScrollEventTarget();
    if (!target) {
        return () => {};
    }
    target.addEventListener("scroll", handler);
    return () => {
        target.removeEventListener("scroll", handler);
    };
}
